import almoxarifado from './almoxarifado'
import equipe from './equipe'
import financeiro from './financeiro'
import servico from './servico'
import frotas from './frotas'

export default [
  ...equipe,
  ...almoxarifado,
  ...financeiro,
  ...servico,
  ...frotas,
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/Dashboard.vue'),
  },
]
